import Driver from 'driver.js';
import {
  showErrorNotification,
  showNotification,
} from './appActions';
import {
  loopbackPost,
  loopbackPut,
  loopbackGet,
} from '../../loopback';

import {
  GET_SURVEY,
  UPDATE_SECTIONS,
  CLEAR_SURVEY_V2,
  SET_SURVEY_HISTORY_DIFF,
  IS_FETCHED_HISTORY,
  SET_HIGHLIGHT_STEP,
  Survey,
  SurveyHistoryDiff,
  SurveySection,
  SurveyActionTypes,
  AppThunk,
} from '../types';
import ApiClient from '../../loopback/apiClient';

export const createSurvey = (surveyData: Omit<Survey, 'id'|'updatedAt'>): AppThunk => async (dispatch): Promise<void> => {
  try {
    const payload = await loopbackPost('Surveys', surveyData);
    dispatch(showNotification(`Successfully created survey: ${payload.id}`));
  } catch (error: any) {
    dispatch(showErrorNotification(`Error during creating survey: ${error.stack}`));
  }
};

// To update a survey, USE the put/Surveys/{id}.
// the remote hook has been setup (replaceById).
// By best practice, remote hook is for remote methods and this should be on "observe"
// But to save time, we will look at this in a later time
export const updateSurvey = (surveyData: Survey): AppThunk => async (dispatch): Promise<void> => {
  try {
    const payload = await loopbackPut(`Surveys/${surveyData.id}`, surveyData);
    dispatch(showNotification(`Successfully udpated survey: ${payload.id}`));
  } catch (error: any) {
    dispatch(showErrorNotification(`Error during patching survey: ${error.stack}`));
  }
};

export const getSurvey = (trialId: number): AppThunk => async (dispatch): Promise<void> => {
  const filter = {
    where: { trialId },
  };

  try {
    const payload = await loopbackGet(`Surveys?filter=${JSON.stringify(filter)}&locale=*`);
    dispatch({
      type: GET_SURVEY,
      payload: payload.length > 0 ? payload[0] : null,
    });
  } catch (error: any) {
    dispatch(showErrorNotification(`Error during fetch survey: ${error.stack}`));
  }
};

export const updateSections = (sections: SurveySection[]): SurveyActionTypes => ({
  type: UPDATE_SECTIONS,
  payload: sections,
});

export const clearSurveyRecord = (): SurveyActionTypes => ({
  type: CLEAR_SURVEY_V2,
});

const setSurveyHistory = (surveyHistoryDiff: SurveyHistoryDiff): SurveyActionTypes => ({
  type: SET_SURVEY_HISTORY_DIFF,
  payload: surveyHistoryDiff,
});

const isFetchedHistory = (isFetching: boolean): SurveyActionTypes => ({
  type: IS_FETCHED_HISTORY,
  payload: isFetching,
});

export const fetchLatestSurveyHistoryDiff = (
  surveyId: number, dateOnwards: string,
): AppThunk => async (dispatch, getState): Promise<void> => {
  const state = getState();
  if (state.surveyV2.isFetchedHistory) {
    return;
  }
  dispatch(isFetchedHistory(true));
  const surveyHistoryDiff = await ApiClient.getSurveyHistoryDiff(surveyId, dateOnwards);
  if (Object.entries(surveyHistoryDiff).length) {
    dispatch(setSurveyHistory(surveyHistoryDiff));
  }
};

export const setHighlightStep = (highlightSteps: Driver.Step[] | undefined): SurveyActionTypes => ({
  type: SET_HIGHLIGHT_STEP,
  payload: highlightSteps,
});
